// core
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';

// angular bootstrap 4
import {ModalModule} from 'ngx-bootstrap/modal';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

// services
import {PreviousPageService} from './services/previous-page.service';
import {SearchAndPaginationService} from "app/shared/services/search-and-pagination.service";
import {DomainService} from './services/domain.service';

// components
import {DeleteConfirmationModalComponent} from './dialogs/delete-modal/delete-modal.component';
import {DatePickerInput} from './date-picker-input/date-picker-input.component';
import {PaginationComponent} from './pagination/pagination.component';

// pipes
import {LocalizedDatePipe} from './pipes/localized-date.pipe';

// modules
import {NgSelectModule} from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        ModalModule.forRoot(),
        TranslateModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        FlexLayoutModule,
        LocalizedDatePipe
    ],
    declarations: [
        DeleteConfirmationModalComponent,
        DatePickerInput,
        PaginationComponent
    ],
    exports: [
        DeleteConfirmationModalComponent,
        DatePickerInput,
        PaginationComponent,
        LocalizedDatePipe
    ],
    providers: [
        PreviousPageService,
        SearchAndPaginationService,
        DomainService
    ]
})
export class SharedModule {

  constructor(@Optional() @SkipSelf() parentModule: SharedModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
